/*
 * axios 封装
 * */

import axios from 'axios'
import store from '@/store/index'
import router from '@/router/index'
import { getToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
import qs from 'qs'
import app from '../store/modules/app';

//axios 配置
//axios.default.timeout = 5000;
//axios.default.baseURL = 'http://192.168.1.171:57574';
let baseURL = '/api'
if(location.hostname == 'localhost'){
	 // baseURL= 'http://localhost:52607/api';
  // baseURL= 'https://localhost:5001/api';
  baseURL= 'https://mp.haiyunfec.org.cn/api';
}
// else{
//   baseURL= 'https://ztj.minica.cn/api';
// }

const server = axios.create({
  baseURL: baseURL, // api的base_url
  timeout: 1000*60*60*24,                  // 请求超时时间
})


const http = axios.create({
  baseURL: baseURL, // api的base_url
  timeout: 1000*60, // 请求超时时间
})


// request拦截器
server.interceptors.request.use(
	config => {
		// if(store.getters.token){
		// 	config.headers['Authorization'] = getToken(); //为每个请求带上token
		// }
		if( getToken()){
			config.headers['Authorization'] = getToken(); //为每个请求带上token
		}
		config.headers['Content-Type'] = 'application/json'
		return config;
	},

	error => {
		console.log(error) // for debug
  		Promise.reject(error)
	}
)

// respone拦截器
server.interceptors.response.use(
	response => {
		if(response.data.State!=1){
			Message({
				message: response.data.ErrorMsg,
				type: 'error',
				showClose: true,
				duration: 3 * 1000
			});
		}
		if(response.data.State==0){ //登录失效
			removeToken();
			router.push({ path: "/"})
		}
		//返回数据
		return response;
	},
	error => {
		console.log('err' + error)// for debug
		if(error.response && error.response.status==401){
			removeToken();
			router.push({ path: "/"})
		}else{
		}

    Message({
      message: error.message,
      type: 'error',
      showClose: true,
      duration: 3 * 1000
    });
    return Promise.reject(error);

	}
)


export default server

export {
  baseURL
}



// WEBPACK FOOTER //
// ./src/utils/server.js